import React, { useEffect } from 'react';
import ActionsFooterFacelift from '../../../../components/ActionsFooterFacelift';
import { DEFAULT_RESPONSIBLE_OF_CONSTRUCTION } from '../../../../store/ducks/contracts-and-constructions/types';
import { IResponsibleOfConstruction } from '../../../../store/ducks/fabrication-contracts/types';
import { EConstructionRegistrationRoutes } from '../constructionRegistration.routes';
import { isAllFieldsValidInResponsiblesOfConstruction } from '../constructionRegistrationFieldsValidations';
import {
  ConstructionRegistrationBlock,
  ConstructionRegistrationBlockHeader
} from '../styles';
import ResponsibleItem from './ResponsibleItem';
import { AddResponsibleButtonContainer } from './styles';
import { Button, Icon, Title } from '@gerdau/hefesto';
import { TableMenu } from '@gerdau/hefesto-mais-web';
import { getTaggingInformationScreen } from '../../../../utils/Tagging';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

interface IResponsibleOfConstructionProps {
  goToConstructionRegistrationRoute(
    route: EConstructionRegistrationRoutes
  ): void;
  responsiblesOfConstruction: IResponsibleOfConstruction[];
  setResponsiblesOfConstruction(
    responsiblesOfConstruction: IResponsibleOfConstruction[]
  ): void;
}

const ResponsibleOfConstruction: React.FC<IResponsibleOfConstructionProps> = ({
  goToConstructionRegistrationRoute,
  responsiblesOfConstruction,
  setResponsiblesOfConstruction
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { screenName = '', itemDescription = '' } = getTaggingInformationScreen(
    history.location.pathname,
    true
  );

  useEffect(() => {
    dispatch(
      sendTagging({
        screenName,
        page: location.pathname,
        event: 'page_view'
      })
    );
  }, []);

  const onUpdateResponsible = (responsible: IResponsibleOfConstruction) => {
    const responsiblesAux = responsiblesOfConstruction.map((resp, idx) =>
      idx === responsible.key ? responsible : resp
    );

    setResponsiblesOfConstruction(responsiblesAux);
  };

  const onAddResponsible = () => {
    setResponsiblesOfConstruction([
      ...responsiblesOfConstruction,
      DEFAULT_RESPONSIBLE_OF_CONSTRUCTION
    ]);
    dispatch(
      sendTagging({
        screenName,
        itemName: 'button:adicionar_responsavel',
        event: 'click',
        itemDescription: `${itemDescription}_adicionarResponsavel`
      })
    );
  };

  const onRemoveResponsibleItemClick = (idx: number) => {
    if (responsiblesOfConstruction.length > 1) {
      const updatedItens = [...responsiblesOfConstruction];
      updatedItens.splice(idx, 1);
      setResponsiblesOfConstruction(updatedItens);
    } else {
      setResponsiblesOfConstruction([DEFAULT_RESPONSIBLE_OF_CONSTRUCTION]);
    }
  };

  return (
    <div>
      <ConstructionRegistrationBlockHeader>
        <Title level={2}>Cadastre os responsáveis pela obra</Title>

        <span className="sub-titleFacelift">
          Adicione contatos extras que ficarão responsáveis pelo contato com a
          Gerdau, dentre outras funções, como recebimento dos materiais.
        </span>
      </ConstructionRegistrationBlockHeader>

      <ConstructionRegistrationBlock isFacelift>
        <AddResponsibleButtonContainer>
          <TableMenu
            leftComponents={<></>}
            rightComponents={
              <span>
                <Button
                  name="addResponsibleButton"
                  type="button"
                  variant="secondary"
                  onClick={onAddResponsible}
                  icon={<Icon option="Plus" />}
                >
                  Adicionar responsável
                </Button>
              </span>
            }
          />
        </AddResponsibleButtonContainer>

        <ResponsibleItem
          responsibles={responsiblesOfConstruction}
          setResponsible={(responsible: IResponsibleOfConstruction) =>
            onUpdateResponsible(responsible)
          }
          onRemoveItem={onRemoveResponsibleItemClick}
          isTheOnlyItem={responsiblesOfConstruction.length === 1}
        />
      </ConstructionRegistrationBlock>

      <ActionsFooterFacelift
        nextStepText="Avançar para revisão"
        onNextStepClick={() => {
          dispatch(
            sendTagging({
              screenName,
              itemName: 'button:avancar_para_revisao',
              event: 'click',
              itemDescription: `${itemDescription}_avancarParaRevisao`
            })
          );
          goToConstructionRegistrationRoute(
            EConstructionRegistrationRoutes.CHECKOUT
          );
        }}
        onBackClick={() => {
          dispatch(
            sendTagging({
              screenName,
              itemName: 'button:voltar',
              event: 'click',
              itemDescription: `${itemDescription}_voltar`
            })
          );
          goToConstructionRegistrationRoute(
            EConstructionRegistrationRoutes.DELIVERY_CONDITIONS
          );
        }}
        disabledNextStep={
          !isAllFieldsValidInResponsiblesOfConstruction(
            responsiblesOfConstruction
          )
        }
      />
    </div>
  );
};

export default ResponsibleOfConstruction;
